import {
  Toolbar,
  SaveButton,
  List,
  SimpleForm,
  DateInput,
  DateField,
  TextInput,
  Datagrid,
  Edit,
  Create,
  TextField,
  ReferenceField,
  ReferenceInput,
  NumberInput,
  NumberField,
  SelectInput,
  required,
  Show,
  SimpleShowLayout,
  useRefresh,
  useUpdate,
  Button,
  BooleanField,
  FormDataConsumer,
  ReferenceManyField,
  Filter,
  SearchInput,
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { ImageFieldCustom, ImageInputCustom, ExtraPagination } from './utils'

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
})

export const CustomToolbar = (props) => (
  <Toolbar {...props} classes={useStyles()}>
    <SaveButton />
  </Toolbar>
)

const CoFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
  </Filter>
)

export const PrefList = (props) => (
  <List
    {...props}
    bulkActionButtons={false}
    exporter={false}
    pagination={<ExtraPagination />}
    filters={<CoFilter />}
  >
    <Datagrid rowClick="edit">
      <NumberField source="id" label="Id" />
      <TextField source="copro_id" label="Id copromatic" />
      <TextField source="name" label="Nom" />
      <TextField source="pref_contact" label="Préférence de contact" />
      <TextField source="consent" label="Consentement tout numérique" />
    </Datagrid>
  </List>
)

export const PrefEdit = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm toolbar={<CustomToolbar />} variant="outlined">
        <SelectInput
          source="pref_contact"
          label="Préférence contact"
          choices={[
            { id: 'all', name: 'Email et SMS' },
            { id: 'email', name: 'Email' },
            { id: 'sms', name: 'SMS' },
          ]}
        />
      </SimpleForm>
    </Edit>
  )
}
